import { Routes } from '@angular/router';
import { BitbucketAuthorizedPageComponent } from '@mogenius/git/pages/bitbucket-callbacks/bitbucket-authorized-page/bitbucket-authorized-page.component';
import { GithubAuthorizedPageComponent } from '@mogenius/git/pages/github-callbacks/github-authorized-page/github-authorized-page.component';
import { GitlabAuthorizedPageComponent } from '@mogenius/git/pages/gitlab-callbacks/gitlab-authorized-page/gitlab-authorized-page.component';
import { AuthorizedGuard } from '@mogenius/user/guards/authorized/authorized.guard';
import { EmailValidGuard } from '@mogenius/user/guards/email-valid/email-valid.guard';
import { LoggedOutUserOutletComponent } from '@mogenius/user/outlets/logged-out.user-outlet/logged-out.user-outlet.component';
import { WorkspaceGithubAuthorizedPageComponent } from '@mogenius/workspace/pages/git-integration/authorized/workspace-github-authorized-page/workspace-github-authorized-page.component';

export const appRoutes: Routes = [
  {
    path: 'user',
    component: LoggedOutUserOutletComponent,
    loadChildren: () => import('./modules/user/user.routes').then((m) => m.userRoutes)
  },

  {
    path: 'studio',
    loadChildren: () => import('./modules/studio/studio.routes').then((m) => m.studioRoutes),
    canMatch: [AuthorizedGuard],
    canActivate: [EmailValidGuard]
  },

  {
    path: 'github/authorized',
    component: GithubAuthorizedPageComponent
  },
  {
    path: 'gitlab/authorized',
    component: GitlabAuthorizedPageComponent
  },
  {
    path: 'bitbucket/authorized',
    component: BitbucketAuthorizedPageComponent
  },

  /** Git integrations */
  {
    path: 'workspace/git-integration/github/authorized',
    component: WorkspaceGithubAuthorizedPageComponent
  },
  {
    path: 'workspace/git-integration/gitlab/authorized',
    component: GitlabAuthorizedPageComponent
  },
  {
    path: 'workspace/git-integration/bitbucket/authorized',
    component: BitbucketAuthorizedPageComponent
  },

  {
    path: 'ai-chat-window',
    loadComponent: () =>
      import('./modules/ai-insights/pages/ai-chat-window-page/ai-chat-window-page.component').then(
        (m) => m.AiChatWindowPageComponent
      ),
    canMatch: [AuthorizedGuard]
  },

  {
    path: 'port-forward-tunnel/error',
    loadComponent: () =>
      import('./modules/kubernetes-resource/pages/port-forward-tunnel-error-page/port-forward-tunnel-error-page.component').then(
        (m) => m.PortForwardTunnelErrorPageComponent
      )
  },

  {
    path: '**',
    redirectTo: 'user'
  }
] satisfies Routes;
